import { useQuery } from '@tanstack/react-query';
import type { HomeData } from './types';

const KEY = ['plan2cost', 'page-accueil', 'home'] as const;

/** `?projets=0` dans l'URL du prototype affiche l'état vide. */
function emptyParam(): boolean {
  return new URLSearchParams(window.location.search).get('projets') === '0';
}

export function useHome() {
  const empty = emptyParam();
  return useQuery<HomeData>({
    queryKey: [...KEY, empty],
    queryFn: async () => {
      const res = await fetch(`/api/plan-accueil/home${empty ? '?empty=1' : ''}`);
      if (!res.ok) throw new Error(`Erreur ${res.status}`);
      return res.json() as Promise<HomeData>;
    },
  });
}
